import {AfterViewInit, Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Utils} from '@astek/utils';
import {RoutesEnum} from '../../../core/services/navigation/routes.enum';
import {PatientData} from '../services/data/patient-data';
import {MeasureTypeEnum} from '../../../core/services/state/measure-type.enum';
import {PressureUnitUtils} from '../../../core/utils/pressure-unit-utils';
import {FormBuilder, FormControl} from '@angular/forms';

@Component({
  selector: 'xp-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: [
    '../../crud.common.scss',
    './patient-details.component.scss',
  ],
})
export class PatientDetailsComponent implements AfterViewInit {

  public readonly formGroup = this._formBuilder.group({
    comment: new FormControl<string>(''),
  });

  private readonly _patientData: PatientData;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _formBuilder: FormBuilder,
  ) {
    this._patientData = this._activatedRoute.snapshot.data['patientData'] as PatientData;
  }

  public get titleKey(): string {
    if (Utils.isNullOrUndefined(this.patientData)) {
      return 'PATIENTS.DETAILS.TITLE.LOADING';
    }
    return `PATIENTS.DETAILS.TITLE.${Utils.enumName(this.patientData.measureType, MeasureTypeEnum)}`;
  }

  public get patientData(): PatientData | null {
    return this._patientData;
  }

  public get patientListRoute(): Array<string> {
    return ['/', RoutesEnum.PATIENTS];
  }

  public get hasShunt(): boolean {
    return Utils.isNotNullOrUndefined(this._patientData.shunt);
  }

  public get shuntAdjustment(): number | null {
    const adjustment = this.patientData?.shunt?.adjustment;
    if (Utils.isNullOrUndefined(this.patientData) || Utils.isNullOrUndefined(adjustment)) {
      return null;
    }

    return Math.round(PressureUnitUtils.convertMmHgToUnit(
      adjustment,
      this.patientData.pressureUnit,
    ));
  }

  public ngAfterViewInit(): void {
    this.formGroup.controls.comment.setValue(this._patientData.comments);
  }

}
